import React from 'react';
import { bool, func } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  title: {
    fontWeight: 700,
    color: '#525f73',
    fontSize: 20,
    marginBottom: 10,
  },
  message: {
    textAlign: 'center',
    maxWidth: 190,
    margin: '0 auto 50px',
  },
});

const DialogClose = withStyles(styles)(props => {
  const { classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      {onClose ? (
        <button aria-label="close" className={classes.closeButton} onClick={onClose}>
          <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true" height="24px" width="24px" fill="#94a2b7">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          </svg>
        </button>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogTitle = withStyles(styles)(props => {
  const { classes } = props;
  return (
    <h3 className={classes.title}>Thank You for Submitting the Survey</h3>
  );
});
const DialogMessage = withStyles(styles)(props => {
  const { classes } = props;
  return (
    <div className={classes.message}>We will notify you via email as soon as it{"'"}s ready.</div>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    paddingLeft: 50,
    paddingRight: 50,
  },
}))(MuiDialogContent);

const ConfirmationDialog = ({ isOpen, onClose }) => {
  return (
    <div>
      <Dialog onClose={onClose} aria-labelledby="customized-dialog-title" open={isOpen}>
        <DialogClose id="customized-dialog-title" onClose={onClose} />
        <DialogContent>
          <DialogTitle />
          <DialogMessage />
        </DialogContent>
      </Dialog>
    </div>
  );
};

ConfirmationDialog.propTypes = {
  isOpen: bool,
  onClose: func,
};

export default ConfirmationDialog;

